var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBellIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3984 15.0449C17.6328 15.2793 17.75 15.5918 17.75 15.8652C17.7109 16.5293 17.2422 17.1152 16.4609 17.1152H1.5C0.71875 17.1152 0.25 16.5293 0.25 15.8652C0.210938 15.5918 0.328125 15.2793 0.5625 15.0449C1.30469 14.2246 2.75 13.0137 2.75 8.99023C2.75 5.98242 4.85938 3.56055 7.75 2.93555V2.11523C7.75 1.45117 8.29688 0.865234 9 0.865234C9.66406 0.865234 10.2109 1.45117 10.2109 2.11523V2.93555C13.1016 3.56055 15.2109 5.98242 15.2109 8.99023C15.2109 13.0137 16.6562 14.2246 17.3984 15.0449ZM2.86719 15.2402H15.0938C14.2734 14.1855 13.375 12.3496 13.3359 9.0293C13.3359 9.0293 13.375 9.0293 13.375 8.99023C13.375 6.60742 11.3828 4.61523 9 4.61523C6.57812 4.61523 4.625 6.60742 4.625 8.99023C4.625 9.0293 4.625 9.0293 4.625 9.0293C4.58594 12.3496 3.6875 14.1855 2.86719 15.2402ZM9 20.8652C7.59375 20.8652 6.5 19.7715 6.5 18.3652H11.4609C11.4609 19.7715 10.3672 20.8652 9 20.8652Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBellIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BellIcon.bcdf7b7c3c4b6de5eb4df1d228feeae0.svg";